module.exports = __webpack_public_path__ + "img/电梯动画4.56bb146b.png";